<template>
    <div>

        <!-- mensajes de confirmacion -->
        <!--
        <mensajeSistema></mensajeSistema>
        -->

        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="modalCrearActividad" maxWidth="900" @close-modal="$emit('close2')">
                <template v-slot:title>
                    {{ Vartitle }}
                    <v-chip class="ml-2" dark :color="datosSeccion.color_nivel">
                        Nivel: {{ datosSeccion.desc_nivel }}
                        {{ datosSeccion.desc_grado }}
                    </v-chip>
                </template>
                <template v-slot:body>
                    <v-row dense>

                        <v-col cols="12" class="d-flex justify-center">
                            <p class="body-1 mb-0 black--text">
                                <span class="font-weight-black">Unidad: </span> {{ datosSeccion.nombre_tema }} -
                                <span class="font-weight-black">Tema: </span> {{ datosSeccion.nombre_clase }}
                            </p>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center">
                            <v-chip color="primary" dark>
                                Fecha de entrega {{ actividad.fecha_actividad }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-space-between">
                        <v-col cols="12" md="4" class="d-flex justify-center align-center">
                            <AutocompleteComp v-model="actividad.id_tipo_actividad" :items="tipoActividad"
                                item-value="id" item-text="desc_tipo_actividad" textLabel="Tipo de actividad"
                                :rules="validationRules.validateCampoList" />


                        </v-col>
                        <v-col cols="12" md="3" v-if="actividad.id_tipo_actividad == 4" class="d-flex align-center">
                            <v-text-field v-model="desc_otros_tipo_actividad" label="Tipo de actividad"
                                hint="Ingrese el tipo de actividad"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="5" class="d-flex justify-center align-center">
                            <v-text-field v-model="actividad.hora_fin_actividad" label="Hora límite" type="time"
                                min="01:00" max="12:00" :rules="[rul.required, rul.hora]"></v-text-field>
                            <v-radio-group class="ml-4" v-model="actividad.tipo_horaFinal">
                                <v-radio :label="`a. m.`" :value="1" color="teal"></v-radio>
                                <v-radio :label="`p. m.`" :value="0" color="#005aff"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-file-input show-size counter small-chips v-model="archivoSubir"
                                accept=".docx,.pdf,.doc,.pptx" label="Cargar actividad"
                                :rules="fileRules"></v-file-input>
                        </v-col>


                        <!--  Cuderno de trabajo Descargar -->
                        <v-col cols="6" class="py-0">
                            <!-- ACA CUANDO SE MODIFIQUE LA RUTA DEL SPACE Y LA COLUMNA DE LA BD , SE TENDRA QUE USAR EL V-IF -->

                            <v-btn v-if="datosSeccion.cuaderno_trabajo && datosSeccion.tipo_contenido == 1"
                                color="primary" class="mx-2 btn_otro" fab x-small
                                @click="download(URL_SPACE + '/' + datosSeccion.cuaderno_trabajo)">
                                <v-icon>fa-file-download</v-icon>
                            </v-btn>



                            <v-btn v-else-if="datosSeccion.cuaderno_trabajo && datosSeccion.tipo_contenido == 0"
                                color="primary" class="mx-2 btn_otro" fab x-small
                                @click="download(URL_SPACE + '/' + datosSeccion.cuaderno_trabajo)">
                                <v-icon>fa-file-download</v-icon>
                            </v-btn>



                            <v-icon v-else :disabled="true" color="primary">fa-file-download</v-icon>
                            <span v-if="datosSeccion.cuaderno_trabajo && datosSeccion.tipo_contenido == 1"
                                class="text-uppercase"> DESCARGAR CUADERNO DE ACTIVIDADES DE INTELIGENIO</span>
                            <span v-else class="text-uppercase"> Descargar cuaderno de actividades del estudiante</span>

                            <!-- <h5 class="red--text animate__animated animate__pulse animate__infinite infinite"> <v-icon
                                    color="red" x-small>fa-exclamation-triangle</v-icon> Recuerda que debes eliminar la
                                última página (Solucionario) del cuaderno de actividades de inteligenio </h5> -->
                        </v-col>

                        <v-col cols="6" class="py-0">
                            <v-textarea v-model="actividad.observacion_actividad" label="Objetivos de la actividad"
                                rows="2"></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <h3 class="font-weight-black black--text">Lista de estudiantes de la sección:
                                {{ datosSeccion.nombre_seccion }}</h3>

                            <v-data-table :headers="headers" :items="AlumnosSeccion" :sort-by="['ape2_alumno']"
                                :sort-desc="[true]" :disable-pagination="true" :hide-default-footer="true"
                                :fixed-header="true">
                                <template v-slot:[`header.check`]>
                                    SELECCIONAR <br />
                                    <v-simple-checkbox v-model="allSelected" @click="selectAll"></v-simple-checkbox>
                                </template>

                                <template v-slot:[`item.alumno_ap`]="{ item }">
                                    <span>{{ item.ape1_alumno + " " + item.ape2_alumno + " " + item.nombre_alumno
                                        }}</span>
                                </template>

                                <template v-slot:[`item.observacion`]="{ item }">
                                    <v-text-field v-model="item.observacion_docente" label="Observación"
                                        class="pb-0 pt-1" type="text" dense single-line
                                        :disabled="item.alumno_check == false"></v-text-field>
                                </template>


                                <template v-slot:[`item.check`]="{ item }">
                                    <v-simple-checkbox v-model="item.alumno_check"></v-simple-checkbox>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:actions>
                    <v-spacer />
                    <ButtonComp @click="validarSolucionarioCT" textButton="Guardar" iconBut="fas fa-save"
                        normalButton />
                    <ButtonComp @click="$emit('close2')" classButton="ml-2" textButton="Cancelar" classColor="red"
                        normalButton />
                </template>
            </ComunDialogComp>

            <ComunDialogComp v-model="validarSolucionario" Deletedialog titleWindow="Advertencia"
                @close-modal="validarSolucionario = false" @cancel-item="validarSolucionario = false"
                @delete-item="saveItem">
                <template v-slot:body>
                    Recuerda que debes eliminar la última página (Solucionario) del cuaderno de actividades de
                    inteligenio
                </template>
            </ComunDialogComp>

        </v-form>


    </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { BUCKET_ORIGIN_SPACE } from '../../../../helpers/axios';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
// import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { validationRules } from '../../../../helpers/validatorHelpers';




export default {
    name: "crearActividad",
    components: {
        ComunDialogComp,
        ButtonComp,
        AutocompleteComp
    },
    props: ['modalCrearActividad', 'datosSeccion', 'fechaActual', 'eventoAct', 'addWizard'],

    data: () => ({
        paramComponente: { 'id_submodulo': 26, "id_modulo": 7 },
        test: false,
        configColegio: [],
        validarSolucionario: false,
        datoLogin: sessionStorage,
        ruta_api: API_URL,
        URL_SPACE: BUCKET_ORIGIN_SPACE,

        rul: {
            required: value => !!value || 'Campo requerido',
            inputReq: value => !!value || 'Campo requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },
            hora: value => {
                if (value < '01:00') {
                    return 'El formato de la hora ingresada es incorrecto'
                }
                else {
                    if (value >= '13:00') {
                        return 'El formato de la hora ingresada es incorrecto'
                    }
                    return true;
                }
            }

        },
        actividad: {},
        actividadCopia: {},
        tipoActividad: [],
        actividadesEstado: [],
        AlumnosSeccion: [],
        allSelected: false,
        Vartitle: "",
        headers: [
            { text: 'N.° DE DOCUMENTO DE IDENTIDAD', value: 'numdoc_alumno', class: 'header_datatable' },
            { text: 'APELLIDOS Y NOMBRES', value: 'alumno_ap', class: 'header_datatable' },
            { text: 'OBSERVACIÓN', value: 'observacion', class: 'header_datatable', sortable: false },
            { text: 'SELECCIONAR', value: 'check', align: 'center', class: 'header_datatable', sortable: false },
        ],
        archivoSubir: null,
        desc_otros_tipo_actividad: null
    }),
    computed: {
        ...mapGetters('login', ['componenteEvento']),
        validationRules() {
            return validationRules
        },

        fileRules() {
            return [
                (file) => {
                    if (!file) return false; // Permitir que el campo esté vacío
                    const allowedMimeTypes = ["application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/pdf"];
                    if (!allowedMimeTypes.includes(file.type)) {
                        return "El archivo debe ser un documento pdf, pptx o .docx";
                    }
                    const maxSizeInBytes = 1000000 * 10; // Cambia esto al tamaño máximo que desees en bytes
                    return file.size <= maxSizeInBytes || `El archivo debe tener un tamaño máximo de ${maxSizeInBytes / 1024} KB`;
                },
            ];
        },
        rules() {
            const rules = []
            if (this.eventoAct == 'agregar') {
                const rule = v => !!v || 'Campo requerido'
                rules.push(rule)
            }
            return rules
        },
    },

    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        modalCrearActividad: function () {
            if (this.modalCrearActividad) {
                this.loadMain()
            } else {
                this.actividad = {}
                this.AlumnosSeccion = []
            }
        }
    },


    mounted() {
        this.loadMain()

    },


    created() {
        this.actualizarParamentro()


    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ////////////////////////////////////////////////////////


        //  ------- Cargar todos los registros principales al iniciar el componente   --------
        async loadMain() {
            this.limpiarFormAct()

            try {
                if (this.eventoAct == 'agregar') {

                    let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/seccion/${this.datosSeccion.id_seccion}/usuario/${this.datoLogin.id}`
                    let response = await axios.get(`/academico/actividades/crearActividad${params}`)
                    let data = response.data
                    this.Vartitle = "Crear actividad - "
                    this.tipoActividad = data.ActividadesTipo
                    this.actividadesEstado = data.ActividadesEstado
                    this.AlumnosSeccion = data.SeccionAlumno
                }

                if (this.eventoAct == 'editar') {
                    this.Vartitle = "Editar actividad - "
                    this.actividad = await Object.assign({}, this.datosSeccion)
                    this.actividadCopia = await Object.assign({}, this.datosSeccion)
                    this.actividad.id = this.datosSeccion.id_actividad
                    this.actividad.id_prog_docente = this.datosSeccion.id
                    this.actividad.id_usuario = this.datoLogin.id
                    this.actividad.evento = this.eventoAct

                    let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/seccion/${this.datosSeccion.id_seccion}/actividad/${this.datosSeccion.id_actividad}/usuario/${this.datoLogin.id}`
                    let response = await axios.get(`/academico/actividades/editarActividad${params}`)
                    var data = response.data

                    this.tipoActividad = data.ActividadesTipo
                    this.actividadesEstado = data.ActividadesEstado
                    this.AlumnosSeccion = data.SeccionAlumno
                    this.desc_otros_tipo_actividad = this.actividad.id_tipo_actividad == 4 ? this.actividad.desc_tipo_actividad : ""

                    let hora_fin = parseInt(this.actividadCopia.hora_fin_actividad.substr(0, 2))
                    //formateamos la hora de fin
                    if (hora_fin >= 12) {
                        let horaFin = hora_fin
                        var horaFinFormato = ''

                        if (hora_fin == 12) {
                            horaFinFormato = this.actividadCopia.hora_fin_actividad
                        }
                        else if (hora_fin > 12 && hora_fin < 22) {
                            horaFinFormato = `0${horaFin - 12}:${this.actividadCopia.hora_fin_actividad.substr(3, 2)}`
                        }
                        else {
                            horaFinFormato = `${horaFin - 12}:${this.actividadCopia.hora_fin_actividad.substr(3, 2)}`
                        }

                        this.actividad.hora_fin_actividad = horaFinFormato
                        this.actividad.tipo_horaFinal = 0
                    }

                    else if (hora_fin == 0) {
                        // let horaFin = hora_fin

                        horaFinFormato = `12:${this.actividadCopia.hora_fin_actividad.substr(3, 2)}`

                        this.actividad.hora_fin_actividad = horaFinFormato
                        this.actividad.tipo_horaFinal = 1
                    }

                    else {
                        this.actividad.hora_fin_actividad = this.actividadCopia.hora_fin_actividad
                        this.actividad.tipo_horaFinal = 1
                    }

                    if (data.mensaggeT == "E") {
                        this.setEnviarMens({ tipo: data.mensaggeT, mensaje: data.mensagge, tiempo: null })
                    }
                }
            }

            catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: e, tiempo: null })
            }
        },
        // async download(url){                

        //     await this.$Files['downloadFetch']({url});       
        // },

        async download(url) {

            const _url = url.split("/");

            try {
                let response = await fetch(url);
                if (response) {
                    // Para entender mejor esto pueden leer el archivo file.js
                    this.$Files['downloadFetch']({ url: url, filename: _url[_url.length - 1] });
                }
            } catch (error) {
                if (error) {
                    let resp = error.response.data;
                    this.setEnviarMens({
                        tipo: resp.messageT,
                        mensaje: ` ${resp.message}`,
                        tiempo: null,
                    });
                }
            }
        },


        selectAll() {

            if (this.allSelected) {
                this.AlumnosSeccion.forEach(function (item) {
                    item.alumno_check = true
                })
            } else {

                this.AlumnosSeccion.forEach(function (item) {
                    item.alumno_check = false
                })

            }

        },

        limpiarFormAct() {
            this.actividad = {
                id_prog_docente: this.datosSeccion.id, id_tipo_actividad: '', fecha_actividad: this.fechaActual,
                hora_fin_actividad: '', ruta_actividad: '', archivo_actividad: '', observacion_actividad: '',
                id_usuario: this.datoLogin.id, id_estado_actividad: 1, evento: this.eventoAct, id: ''
            }

            this.archivoSubir = null

            this.AlumnosSeccion = []

            this.$refs.formDatos.resetValidation()

            this.desc_otros_tipo_actividad = ""
        },
        validarSolucionarioCT() {

            if (this.actividad.id_tipo_actividad == 5) {
                this.validarSolucionario = true;
            } else {
                this.saveItem();
            }
        },
        async saveItem() {
            //this.setEnviarMens({tipo:"W", mensaje: `Guardar Archivo`, tiempo:null})
            if (this.$refs.formDatos.validate()) {

                if (this.AlumnosSeccion == '') {
                    this.setEnviarMens({ tipo: 'E', mensaje: 'No hay estudiantes en la sección', tiempo: null })
                } else {
                    let found = this.AlumnosSeccion.find(element => element.alumno_check == true)

                    if (found) {
                        try {
                            var res = ""
                            let respMensaje = ""
                            //configuramos la hora de finalizacion
                            // hora pm menor a 12
                            if (this.actividad.tipo_horaFinal == 0 && this.actividad.hora_fin_actividad.substr(0, 2) < 12) {
                                let horaIni = parseInt(this.actividad.hora_fin_actividad.substr(0, 2));
                                let horaFormato = `${horaIni + 12}:${this.actividad.hora_fin_actividad.substr(3, 2)}`;
                                this.actividad.hora_fin = horaFormato;
                            }
                            // hora am igual a 12
                            else if (this.actividad.tipo_horaFinal == 1 && this.actividad.hora_fin_actividad.substr(0, 2) == 12) {
                                let horaFormato = `00:${this.actividad.hora_fin_actividad.substr(3, 2)}`;
                                this.actividad.hora_fin = horaFormato
                            }
                            // hora am menor a 12 ó hora pm igual a 12
                            else {
                                this.actividad.hora_fin = this.actividad.hora_fin_actividad
                            }

                            if (this.eventoAct == 'agregar') {
                                res = await axios.post("/academico/actividades/", { actividad: { ...this.actividad, otros_tipo_actividad: this.desc_otros_tipo_actividad }, alumnos: this.AlumnosSeccion })
                            
                                respMensaje = "¡Información creada con éxito!"
                                if (this.addWizard == false) {
                                    this.$emit('calendario_actualizar')
                                }
                            }
                            if (this.eventoAct == 'editar') {
                                res = await axios.put("/academico/actividades/", { actividad: { ...this.actividad, otros_tipo_actividad: this.desc_otros_tipo_actividad }, alumnos: this.AlumnosSeccion })
                                //    var res = await axios.put("/sistema/usuarioManager/"+this.datos.id,this.datos)
                                this.$emit('actvidades_actualizar')
                                respMensaje = "¡Información creada con éxito!"
                            }
                            this.savenotif();
                            this.setEnviarMens({ tipo: 'S', mensaje: respMensaje, tiempo: null })

                            //Aca se subira al SPACE
                            if (this.archivoSubir) {
                                this.saveFile(res.data.lastInsert)
                            }
                            this.$emit('close2')
                            this.limpiarFormAct()
                            this.validarSolucionario = false

                        } catch (error) {
                            this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                        }
                    }
                    else {
                        this.setEnviarMens({ tipo: "W", mensaje: 'No ha seleccionado ningún estudiante de la lista', tiempo: null })
                    }
                }
            }
        },

        async savenotif() {
            let titulo = ''
            let contenido = ''
            let action = 0
            if (this.eventoAct == 'agregar') {
                titulo = 'Actividad creada'
                contenido = 'Se le asigno una nueva actividad'
                action = 'fas fa-plus-square'
            } else if (this.eventoAct == 'editar') {
                titulo = 'Se edito la actividad'
                contenido = 'Se edito la actividad que se le fue asignada'
                action = 'fas fa-edit'
            }
            const fechaActual = new Date();
            const horaActual = fechaActual.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });
            const filteredUsers = this.AlumnosSeccion.filter(user => user.alumno_check);

            const datanotif = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                titulo_notif: titulo,
                contenido_notif: contenido,
                id_perfil: this.datoLogin.id_perfil,
                id_usuario: this.datoLogin.id,
                fecha_notif: fechaActual,
                hora_notif: horaActual,
                fecha_venc: this.actividad.fecha_actividad,
                id_seccion: this.datosSeccion.id_seccion,
                id_curso: this.datosSeccion.id_curso,
                tema_clase: this.datosSeccion.nombre_clase,
                icon_notif: action,
                event_action: this.eventoAct,
                type_notif: 'actividad',
                alumnos: filteredUsers,
            };

            try {
                const response1 = await axios.post("/notification/persona/addusernotif/", datanotif);
                this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }

        },

        // async pushnotificationFamEmail(datanotif) {
        //     try {
        //         const response = await axios.get(`/notification/persona/getConfigColegio/${this.datoLogin.id_colegio}`);
        //         let data = response.data

        //         if (data.rest_report_actividades == true) {
        //             try {
        //                 const response1 = await axios.post("/notification/persona/sendmailFam/", datanotif)
        //                 this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
        //             } catch (error) {
        //                 console.log(error);
        //                 this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //             }
        //         }

        //     } catch (error) {
        //         console.log(error);
        //         this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //     }
        // },



        async saveFile(id) {
            if (!this.archivoSubir) {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe subir un archivo `, tiempo: null })
            }

            else {
                try {
                    let formData = new FormData()
                    formData.append('subirArchivo', this.archivoSubir)
                    formData.append('usuario', this.datoLogin.id)
                    formData.append('colegio', this.datoLogin.id_colegio)
                    formData.append('periodo', this.datoLogin.id_ano_lectivo)
                    formData.append('nivel', this.datosSeccion.id_nivel)
                    formData.append('grado', this.datosSeccion.id_grado)
                    formData.append('seccion', this.datosSeccion.id_seccion)
                    formData.append('procedenciaArchivo', 'docente')
                    formData.append('actividad', id)

                    await axios.post('/academico/progDocente/addActividad/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    )
                }

                catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })

                }
            }
        },



    }
};
</script>